import styled from "@emotion/styled";

export const HoopsWrapper = styled.div`
  position: relative;
  min-height: 350px;
`;

export const Container = styled.div`
  position: relative;
  min-height: 350px;
  height: calc(100%);
`;

export const Name = styled.div`
  font-family: "Open Sans";
  font-size: 18px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 7px;
  left: 16px;
  width: 100%;
  max-width: 100%;
  padding-right: 100px;
`;

export const Dimensions = styled.div`
  position: absolute;
  bottom: 30px;
  right: 15px;
  margin: 5px;
  padding: 0px 5px;
  background-color: rgba(255, 255, 255, 0.8);
`;
